import { getToken } from "firebase/messaging";
import { getMessagingIfSupported, VAPID_KEY } from "./firebase";

export const requestNotificationPermission = async () => {
  try {
    const messaging = await getMessagingIfSupported();
    if (!messaging) {
      console.log("Acest browser nu suporta notificari.");
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permisiunea pentru notificari nu a fost acordata.");
      return null;
    }

    const serviceWorkerRegistration =
      await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration
    });

    if (token) {
      console.log("FCM TOKEN:", token);
      return token;
    }

    console.log("Nu s-a putut obtine tokenul.");
    return null;
  } catch (error) {
    console.error("Eroare la activarea notificarilor:", error);
    return null;
  }
};
